import { render } from "./SubAreas.vue?vue&type=template&id=618a42ae&scoped=true"
import script from "./SubAreas.vue?vue&type=script&scoped=true&lang=js"
export * from "./SubAreas.vue?vue&type=script&scoped=true&lang=js"

import "./SubAreas.vue?vue&type=style&index=0&id=618a42ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618a42ae"]])

export default __exports__